import IconButton from '@mui/material/IconButton';
import { Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useState } from 'react';
import { ReactComponent as ViewIcon } from '../../assets/view.svg';
import { ReactComponent as LogIcon } from '../../assets/log.svg';
import { ReactComponent as AttachmentIcon } from '../../assets/attachment.svg';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SyncIcon from '@mui/icons-material/Sync';
import { useDispatch } from 'react-redux';
import { deleteIncident } from '../../store/incidentsReducer';

const TableActionPopup = ({
  params,
  openIncidentInfo,
  handlerSyncNeris,
  permissions,
}) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlerDeleteIncident = () => {
    dispatch(deleteIncident(params.id));
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          '& .MuiMenuItem-root': {
            color: 'rgba(0, 0, 0, 0.54)',
          },
          '& .menuItem_img': {
            marginRight: 1,
          },
        }}
      >
        <MenuItem
          onClick={() => {
            openIncidentInfo(params.row.incident_id);
            handleClose();
          }}
        >
          <ViewIcon className="menuItem_img" /> View
        </MenuItem>

        <MenuItem disabled>
          <LogIcon className="menuItem_img" /> Log
        </MenuItem>

        <MenuItem disabled>
          <AttachmentIcon className="menuItem_img" /> Attachment
        </MenuItem>

        <MenuItem
          onClick={() => {
            handlerSyncNeris(params.id);
            handleClose();
          }}
        >
          <SyncIcon
            className="menuItem_img"
            sx={{
              height: '18px',
              width: '18px',
            }}
          />{' '}
          Sync Neris
        </MenuItem>

        <MenuItem
          onClick={handlerDeleteIncident}
          disabled={!permissions.can_delete}
        >
          <DeleteOutlineIcon
            className="menuItem_img"
            sx={{
              height: '18px',
              width: '18px',
            }}
          />{' '}
          Delete
        </MenuItem>
      </Menu>
    </>
  );
};

export default TableActionPopup;
